import moment from 'moment';
import { dateNumberToMoment } from '../../../../../utils/dateNumberToMoment';

export const filterList = (
  data = [],
  filters,
  startDate,
  endDate,
  assocStores,
  dateFilter = 'created_date',
  associateStoresMap = new Map(),
) => {
  const allStores = assocStores.filter(store => store.id !== 0).map(item => item.id.toString());

  return data?.filter(item => {
    const itemStoreId = item?.store_id?.toString();
    const itemAssociateId = item?.associate_id?.toString();

    // Filter by store: check if item's store matches selected stores
    const filterStore =
      filters.stores?.length === 0 ? allStores.includes(itemStoreId) : filters.stores.includes(itemStoreId);

    // Filter by associate
    const filterAssociate = filters.associate.length === 0 || filters.associate.includes(itemAssociateId);

    // Additional check: if stores filter is active, ensure the associate has access to those stores
    let filterAssociateHasStoreAccess = true;
    if (filters.stores?.length > 0 && itemAssociateId && associateStoresMap.has(itemAssociateId)) {
      const associateStores = associateStoresMap.get(itemAssociateId);
      filterAssociateHasStoreAccess = filters.stores.some(storeId => associateStores.has(storeId));
    }

    // Filter by date
    const filterTimeSpan = moment(
      dateNumberToMoment(item[dateFilter] || item?.created_date || item?.due_date),
    ).isBetween(moment(startDate), moment(endDate), null, '[]');

    return filterStore && filterAssociate && filterAssociateHasStoreAccess && filterTimeSpan;
  });
};
